import React, { useEffect, useState, useRef, useContext } from 'react';
import { DownloadOutlined, UploadOutlined, DeleteOutlined, UserOutlined } from '@ant-design/icons';
import { Outlet, Link, useSearchParams, useNavigate } from "react-router-dom";
import { Row, Col, Button, Table, Popconfirm, Form, Input, Radio, DatePicker, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import FormulaRule from '../formula_calculator/components/FormulaRule';
import dayjs from 'dayjs';
const { RangePicker } = DatePicker;
const EditableContext = React.createContext(null);

const AddTuitionFee = () => {
    const [dataSource, setDataSource] = useState([
        {
            key: '0',
            name: '2023-06-23',
            age: '32',
            address: 'London, Park Lane no. 0',
            operation: 200,
        },
        {
            key: '1',
            name: '2023-06-23',
            age: '32',
            address: 'London, Park Lane no. 1',
            operation: 200,
        },
    ]);
    const [count, setCount] = useState(2);
    const handleDelete = (key) => {
        const newData = dataSource.filter((item) => item.key !== key);
        setDataSource(newData);
    };
    const defaultColumns = [
        {
            title: '日期',
            dataIndex: 'name',
            width: '30%',
            render: (_, record) => (
                <>
                    <DatePicker value={dayjs(record.name, 'YYYY-MM-DD')}></DatePicker>
                </>
            )
        },
        {
            title: '名稱',
            dataIndex: 'age',
            render: (_, record) => (
                <>
                    <Select value={record.age}></Select>
                </>
            )

        },
        {
            title: '單價',
            dataIndex: 'address',
            render: (_, record) => (
                <>
                    <Input value={record.address}></Input>
                </>
            )

        },
        {
            title: '數量',
            dataIndex: 'address',
            render: (_, record) => (
                <>
                    <Input value={record.address}></Input>
                </>
            )

        },
        {
            title: '折讓',
            dataIndex: 'address',
            render: (_, record) => (
                <>
                    <Input value={record.address}></Input>
                </>
            )

        },
        {
            title: '總額',
            dataIndex: 'operation',
            render: (_, record) =>
                dataSource.length >= 1 ? (
                    <>
                        <Row align={'middle'} gutter={8}>
                            <Col span={18}>
                                <Input value={record.operation} width={20}></Input>
                            </Col>
                            <Col span={6}>
                                <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
                                    <DeleteOutlined style={{ color: 'red' }} />
                                </Popconfirm>
                            </Col>
                        </Row>
                    </>
                ) : null,
        },
    ];
    const handleAdd = () => {
        const newData = {
            key: count,
            name: `Edward King ${count}`,
            age: '32',
            address: `London, Park Lane no. ${count}`,
        };
        setDataSource([...dataSource, newData]);
        setCount(count + 1);
    };

    return (
        <>
            <Row gutter={[16, 16]} align={'middle'} justify={'space-between'}>
                <Col style={{ fontWeight: 700, fontSize: '30px' }} span={24}>建立繳費單</Col>
                <Col style={{ fontWeight: 700, fontSize: '28px' }} span={24}>王小明</Col>
                <Col span={24}>
                    <Row gutter={8} align={'middle'}>
                        <Col><span style={{ fontWeight: 700 }}>學費計算</span></Col>
                        <Col>
                            <Radio.Group name="radiogroup" defaultValue={1}>
                                <Radio value={1}>月繳</Radio>
                                <Radio value={2}>季繳</Radio>
                                <Radio value={3}>年繳</Radio>
                                <Radio value={4}>其他</Radio>
                            </Radio.Group>
                        </Col>
                        <Col>
                            <Input width={50}></Input>
                        </Col>
                    </Row>

                </Col>
                <Col span={24}>
                    <Row gutter={8} align={'middle'}>
                        <Col><span style={{ fontWeight: 700 }}>學費期間</span></Col>
                        <Col><RangePicker></RangePicker>  </Col>
                        <Col><span style={{ fontWeight: 700 }}>繳費期限</span></Col>
                        <Col> <DatePicker /> </Col>
                    </Row>
                </Col>
                <Col>
                    <Button
                        onClick={handleAdd}
                        type="primary"
                        style={{
                            marginBottom: 16,
                            color: 'white',
                            backgroundColor: '#2C73D2'
                        }}
                        shape='round'
                    >
                        新增繳費明細
                    </Button>
                </Col>
                <Col>
                    <Row gutter={8}>
                        <Col>
                            <Button
                                // onClick={handleAdd}
                                type="primary"
                                style={{
                                    marginBottom: 16,
                                }}
                                icon={<DownloadOutlined />}
                            >
                                匯出資料
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                // onClick={handleAdd}
                                type="primary"
                                style={{
                                    marginBottom: 16,
                                }}
                                icon={<UploadOutlined />}
                            >
                                匯入資料
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <Col span={24} style={{ backgroundColor: '#FBEAFF', borderRadius: '5px', padding: '5px' }}>
                    111年02月王小明繳費明細
                </Col>
                <Col span={24}>
                    <Table
                        bordered
                        dataSource={dataSource}
                        columns={defaultColumns}
                        pagination={false}
                        footer={() => <><Row justify={'end'} style={{ paddingRight: '8%', color: 'red' }}><Col>800</Col></Row></>}
                        scroll={{
                            y: 240,
                        }}
                    />
                </Col>
                <Col span={24}><span style={{ fontWeight: 700 }}>備註</span></Col>
                <Col span={24}>
                    <TextArea rows={5} placeholder='請輸入備註' />
                </Col>
                <Col span={24}>
                    <Row gutter={16} align={'middle'} justify={'end'}>
                        <Col><span style={{ fontWeight: 700 }}>經手人</span></Col>
                        <Col>
                            <Select width={300} />
                        </Col>
                    </Row>
                </Col>
                <Col></Col>
                <Col span={24}>
                    <Row gutter={16} align={'middle'} justify={'end'}>
                        <Col>
                            <Button style={{ color: 'white', backgroundColor: 'black' }} size='large'>取消</Button>
                        </Col>
                        <Col>
                            <Button style={{ color: 'white', backgroundColor: '#D65DB1' }} size='large'>建立繳費單</Button>
                        </Col>
                    </Row>
                </Col>
                {/* <Col span={24}>
                    <FormulaRule cID="uMonthlySalaryManage" iActiveTab={5} bDebug="true" />
                </Col> */}
            </Row >
        </>
    );
}
export default AddTuitionFee;